module.exports = __webpack_public_path__ + "img/67.04ce8501.jpg";